import React, { Component } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    CircularProgress,
    Typography,
    Box
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

import ErrorDialog from './ErrorDialog';

var request = require('../../utilities/NetworkRequest');

export default class DownloadOrderDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loading: false,
            body_error: {
                is_show: false,
                message: ''
            },
            wholesaler_id: '',
            startDate: '',
            endDate: '',
            status: 'all',
            formatFile: 'csv'
        }
    }

    validateFields() {
        const { startDate, endDate, wholesaler_id } = this.state;
        const { body } = this.props;

        if (body.wholesaler_id === 'TP9999' && !wholesaler_id) {
            return "Wholesaler ID harus diisi.";
        }
        if (!startDate) {
            return "Tanggal mulai harus diisi.";
        }
        if (!endDate) {
            return "Tanggal akhir harus diisi.";
        }
        if (new Date(endDate) < new Date(startDate)) {
            return "Tanggal akhir tidak boleh lebih kecil dari tanggal mulai.";
        }

        return null; // ✅ valid
    }

    downloadOrder() {
        const errorMessage = this.validateFields();
        if (errorMessage) {
            this.setState({
                body_error: {
                    is_show: true,
                    message: errorMessage
                }
            });
            return;
        }

        this.setState({ is_loading: true }, () => {
            let wholesaler_id = this.props.body.wholesaler_id === 'TP9999'
                ? this.state.wholesaler_id
                : this.props.body.wholesaler_id;

            let body = {
                user_id: this.props.body.user_id,
                wholesaler_id: wholesaler_id,
                filter_type: 'filter_tanggal',
                start_date: this.state.startDate,
                end_date: this.state.endDate,
                status_order: this.state.status,
                format: this.state.formatFile
            };

            request.onRequestDataGet(
                1,
                '/download/order',
                body,
                res_data => {
                    this.setState({ is_loading: false }, () => {
                        try {
                            const format = this.state.formatFile;

                            if (format === 'csv') {
                                if (typeof res_data === 'string') {
                                    const blob = new Blob([res_data], { type: 'text/csv;charset=utf-8;' });
                                    const url = window.URL.createObjectURL(blob);
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.download = `data-order-${Date.now()}.csv`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                    window.URL.revokeObjectURL(url);
                                } else {
                                    throw new Error('Format data CSV tidak sesuai.');
                                }
                            } else if (format === 'xlsx') {
                                if (res_data instanceof ArrayBuffer) {
                                    const blob = new Blob([res_data], {
                                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                    });
                                    const url = window.URL.createObjectURL(blob);
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.download = `data-order-${Date.now()}.xlsx`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                    window.URL.revokeObjectURL(url);
                                } else {
                                    throw new Error('Format data XLSX tidak sesuai.');
                                }
                            }
                        } catch (err) {
                            console.error(err);
                            this.setState({
                                body_error: { is_show: true, message: 'Terjadi kesalahan saat mengunduh file.' },
                            });
                        }
                    });
                },
                {
                    // 👉 tambahkan responseType sesuai format file
                    responseType: this.state.formatFile === 'xlsx' ? 'arraybuffer' : 'text',
                }
            );

        });
    }

    showErrorDialog(body) {
        if (body.is_show) {
            return (
                <ErrorDialog
                    body_error={body}
                    onCloseDialog={() => this.setState({ body_error: { is_show: false, message: '' } })}
                />
            );
        } else {
            return null;
        }
    }

    render() {
        const { is_loading, startDate, endDate, status, formatFile } = this.state;
        return (
            <Dialog
                open={true}
                onClose={this.props.onCloseDialog}
                aria-labelledby="download-order-dialog-title"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="download-order-dialog-title">
                    <Box display="flex" alignItems="center">
                        <GetAppIcon style={{ marginRight: 8, color: '#ff9800' }} />
                        <Typography variant="h6">Download Data Order</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {this.showErrorDialog(this.state.body_error)}
                    <Box display="flex" flexDirection="column" gap={2} mb={2}>
                        {this.props.body.wholesaler_id === 'TP9999' && (
                            <TextField
                                label="Wholesaler ID"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={this.state.wholesaler_id}
                                onChange={e => this.setState({ wholesaler_id: e.target.value })}
                                style={{ marginBottom: 16 }}
                            />
                        )}
                        <Box display="flex" gap={2}>
                            <TextField
                                label="Start Date"
                                type="date"
                                variant="outlined"
                                size="small"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={startDate}
                                onChange={e => this.setState({ startDate: e.target.value })}
                                style={{ marginRight: 8 }}
                            />
                            <TextField
                                label="End Date"
                                type="date"
                                variant="outlined"
                                size="small"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={endDate}
                                onChange={e => this.setState({ endDate: e.target.value })}
                                InputProps={{ inputProps: { min: startDate } }}
                            />
                        </Box>
                    </Box>
                    <FormControl variant="outlined" size="small" fullWidth style={{ marginBottom: 16 }}>
                        <InputLabel id="status-label">Status</InputLabel>
                        <Select
                            labelId="status-label"
                            label="Status"
                            value={status}
                            onChange={e => this.setState({ status: e.target.value })}
                        >
                            <MenuItem value="all">Semua</MenuItem>
                            <MenuItem value="0">Antrian</MenuItem>
                            <MenuItem value="1">Diproses</MenuItem>
                            <MenuItem value="2">Dibatalkan</MenuItem>
                            <MenuItem value="3">Dikirimkan</MenuItem>
                            <MenuItem value="4">Diterima</MenuItem>
                            <MenuItem value="5">Ditolak</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel id="status-label">Format File</InputLabel>
                        <Select
                            labelId="status-label"
                            label="Format File"
                            value={formatFile}
                            onChange={e => this.setState({ formatFile: e.target.value })}
                        >
                            <MenuItem value="csv">CSV</MenuItem>
                            <MenuItem value="xlsx">EXCEL</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onCloseDialog} color="default" variant="outlined">
                        Tutup
                    </Button>
                    <Button
                        onClick={() => this.downloadOrder()}
                        color="primary"
                        variant="contained"
                        startIcon={<GetAppIcon />}
                        disabled={is_loading}
                        style={{ backgroundColor: '#ff9800', color: '#fff' }}
                    >
                        {is_loading ? <CircularProgress size={24} color="inherit" /> : 'Download'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}